"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportPortalServiceImpl = exports.Types = exports.Layout = void 0;
var CustomerDetailsPage_1 = require("./pages/customerDetailsPage/CustomerDetailsPage");
var Types_1 = require("./Types");
Object.defineProperty(exports, "Types", { enumerable: true, get: function () { return Types_1.Types; } });
var SupportPortalServiceImpl_1 = require("./services/impl/SupportPortalServiceImpl");
Object.defineProperty(exports, "SupportPortalServiceImpl", { enumerable: true, get: function () { return SupportPortalServiceImpl_1.SupportPortalServiceImpl; } });
var CommunicationPage_1 = require("./pages/CommunicationPage");
var InvoicesAndPaymentsPage_1 = require("./pages/invoicesAndPaymentsPage/InvoicesAndPaymentsPage");
var ClaimUpdatePage_1 = require("./pages/claimsPage/ClaimUpdatePage");
var services_1 = require("@falcon/services");
var RefundPage_1 = require("./pages/refundPage/RefundPage");
var GoodwillPaymentPage_1 = require("./pages/goodwillPaymentPage/GoodwillPaymentPage");
var Layout_1 = require("./Layout");
Object.defineProperty(exports, "Layout", { enumerable: true, get: function () { return Layout_1.Layout; } });
var ClaimsPage_1 = require("./pages/claimsPage/ClaimsPage");
var CreateExternalClaimPage_1 = require("./pages/customerDetailsPage/createExternalClaimPage/CreateExternalClaimPage");
var RawDataDecompressPage_1 = require("./pages/RawDataDecompressPage");
var UnderwritingUpdatesPage_1 = require("./pages/underwritingUpdates/UnderwritingUpdatesPage");
var UnderwritingUpdatePage_1 = require("./pages/underwritingUpdates/UnderwritingUpdatePage");
var CancellationDelayPage_1 = require("./pages/canellationDelayPage/CancellationDelayPage");
var InvoiceCorrectiveMeasuresPage_1 = require("./pages/invoiceCorrectiveMeasures/InvoiceCorrectiveMeasuresPage");
var VulnerableCustomerAdditionalSupportPage_1 = require("./pages/vulnerableCustomerAdditionalSupport/VulnerableCustomerAdditionalSupportPage");
var VulnerableCustomerHistoryPage_1 = require("./pages/vulnerableCustomerHistoryPage/VulnerableCustomerHistoryPage");
var DirectDebitMandateInfoPage_1 = require("./pages/directDebitInfoPage/DirectDebitMandateInfoPage");
var DirectDebitPaymentInfoPage_1 = require("./pages/directDebitInfoPage/DirectDebitPaymentInfoPage");
var DirectDebitDelinquencyStatus_1 = require("./pages/directDebitInfoPage/DirectDebitDelinquencyStatus");
var DirectDebitBacsResponsePage_1 = require("./pages/directDebitInfoPage/DirectDebitBacsResponsePage");
var EditHomeCustomerDetailsPage_1 = require("./pages/customerDetailsPage/EditHomeCustomerDetailsPage");
var VulnerableCustomerPaymentHolidayRestrictionPage_1 = require("./pages/vulnerableCustomerPaymentHolidayPage/VulnerableCustomerPaymentHolidayRestrictionPage");
var VulnerableCustomerPaymentHolidayMonthSelectionPage_1 = require("./pages/vulnerableCustomerPaymentHolidayPage/VulnerableCustomerPaymentHolidayMonthSelectionPage");
var VulnerableCustomerPaymentHolidayConfirmationPage_1 = require("./pages/vulnerableCustomerPaymentHolidayPage/VulnerableCustomerPaymentHolidayConfirmationPage");
var DirectDebitChangePaymentDayPage_1 = require("./pages/directDebitInfoPage/DirectDebitChangePaymentDayPage");
var DirectDebitRenewalChangePaymentDayPage_1 = require("./pages/directDebitInfoPage/DirectDebitRenewalChangePaymentDayPage");
var TreeManagerImpl_1 = require("./services/impl/TreeManagerImpl");
var MainSearchPage_1 = require("./pages/mainAgentPortalPage/customerSearchPage/MainSearchPage");
var InteractionSearchPage_1 = require("./pages/mainAgentPortalPage/interactionSearchPage/InteractionSearchPage");
var CalculateInteractionPage_1 = require("./pages/mainAgentPortalPage/CalculateInteractionPage");
var TransactionSearchPage_1 = require("./pages/mainAgentPortalPage/transactionSearchPage/TransactionSearchPage");
var AdvancedSearchPage_1 = require("./pages/mainAgentPortalPage/customerSearchPage/AdvancedSearchPage");
var plugin = {
    getName: function () {
        return "support";
    },
    register: function (extensions, configuration) {
        // Routes
        extensions.routes.add({
            path: "/",
            component: MainSearchPage_1.MainSearchPage,
        });
        extensions.routes.add({
            path: "/customers/:id",
            component: CustomerDetailsPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/payments",
            component: InvoicesAndPaymentsPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/claims",
            component: ClaimsPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:customerId/claims/:claimId",
            component: ClaimUpdatePage_1.default,
        });
        extensions.routes.add({
            path: "/communications/:id",
            component: CommunicationPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/vulnerableCustomer/paymentHolidays/pendingRepresent",
            component: VulnerableCustomerPaymentHolidayRestrictionPage_1.VulnerableCustomerPaymentHolidayRestrictionPage,
        });
        extensions.routes.add({
            path: "/customers/:id/vulnerableCustomer/paymentHolidays/:policyNumber/process",
            component: VulnerableCustomerPaymentHolidayMonthSelectionPage_1.VulnerableCustomerPaymentHolidayMonthSelectionPage,
        });
        extensions.routes.add({
            path: "/customers/:id/vulnerableCustomer/paymentHolidays/:policyNumber/confirm",
            component: VulnerableCustomerPaymentHolidayConfirmationPage_1.VulnerableCustomerPaymentHolidayConfirmationPage,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/refund",
            component: RefundPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/goodwillPayment",
            component: GoodwillPaymentPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:customerReferenceNumber/editHomeCustomerDetails/:agreementNumber",
            component: EditHomeCustomerDetailsPage_1.EditHomeCustomerDetailsPage,
        });
        extensions.routes.add({
            path: "/customers/policies/:number/delayCancellation/:dueDate/:customer",
            component: CancellationDelayPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:policyNumber/versions/:policyVersionNumber/createExternalClaim",
            component: CreateExternalClaimPage_1.default,
        });
        extensions.routes.add({
            path: "/interactionSearch",
            component: InteractionSearchPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/underwritingUpdates",
            component: UnderwritingUpdatesPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:customerId/underwritingUpdate/:claimNumber",
            component: UnderwritingUpdatePage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/invoiceCorrectiveMeasures/:policyNumber",
            component: InvoiceCorrectiveMeasuresPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/vulnerableCustomer/additionalSupport/:policyNumber",
            component: VulnerableCustomerAdditionalSupportPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/vulnerableCustomer/additionalSupportHistory/:policyNumber",
            component: VulnerableCustomerHistoryPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/directDebitMandateInfoAction",
            component: DirectDebitMandateInfoPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/directDebitPaymentInfoAction",
            component: DirectDebitPaymentInfoPage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/directDebitDelinquencyStatusAction",
            component: DirectDebitDelinquencyStatus_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/directDebitBacsResponseAction",
            component: DirectDebitBacsResponsePage_1.default,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/changePaymentDay/:interactionId",
            component: DirectDebitChangePaymentDayPage_1.DirectDebitChangePaymentDayPage,
        });
        extensions.routes.add({
            path: "/customers/:id/policies/:number/changeRenewalPaymentDay",
            component: DirectDebitRenewalChangePaymentDayPage_1.DirectDebitRenewalChangePaymentDayPage,
        });
        extensions.routes.add({
            path: "/calculateInteraction",
            component: CalculateInteractionPage_1.default,
        });
        extensions.routes.add({
            path: "/transactionSearch",
            component: TransactionSearchPage_1.default,
        });
        extensions.routes.add({
            path: "/decompressData",
            component: RawDataDecompressPage_1.default,
        });
        extensions.routes.add({
            path: "/advancedSearch",
            component: AdvancedSearchPage_1.AdvancedSearchPage,
        });
        // Services
        extensions.services.bind(Types_1.Types.SupportPortalService).to(SupportPortalServiceImpl_1.SupportPortalServiceImpl);
        extensions.services.bind(Types_1.Types.SupportPortalServiceConfig).toConstantValue(configuration.supportPortalApiService);
        extensions.services.bind(Types_1.Types.FalconLookupService).to(services_1.FalconLookupService);
        extensions.services.bind(Types_1.Types.BaseRequestService).to(services_1.BaseRequestServiceImpl);
        extensions.services.bind(Types_1.Types.TreeManager).to(TreeManagerImpl_1.TreeManagerImpl).inSingletonScope();
    }
};
exports.default = plugin;
__exportStar(require("./model"), exports);
//# sourceMappingURL=index.js.map